module.exports = __webpack_public_path__ + "img/11.aae7c768.jpg";